import { alpha } from "@mui/material/styles";

// Personalización de componentes Material-UI
export const components = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        textTransform: "none",
        fontWeight: 500,
        padding: "8px 16px",
      },
      containedPrimary: {
        background: "linear-gradient(45deg, #d32f2f 30%, #f44336 90%)",
        boxShadow: "0 3px 5px 2px rgba(211, 47, 47, .3)",
        "&:hover": {
          background: "linear-gradient(45deg, #b71c1c 30%, #d32f2f 90%)",
          boxShadow: "0 6px 10px 2px rgba(211, 47, 47, .3)",
        },
      },
    },
  },

  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 12,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        transition: "box-shadow 0.3s ease-in-out",
        "&:hover": {
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.15)",
        },
      },
    },
  },

  MuiCardHeader: {
    styleOverrides: {
      root: {
        paddingBottom: 8,
      },
      title: {
        fontSize: "1.25rem",
        fontWeight: 600,
        color: "#212121",
      },
      subheader: {
        fontSize: "0.875rem",
        color: "#757575",
      },
    },
  },

  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: 16,
        fontWeight: 500,
      },
      colorPrimary: {
        backgroundColor: "#d32f2f",
        color: "#ffffff",
      },
    },
  },

  MuiAppBar: {
    styleOverrides: {
      root: {
        background: "linear-gradient(90deg, #d32f2f 0%, #f44336 100%)",
        boxShadow: "0 2px 8px rgba(211, 47, 47, 0.2)",
      },
    },
  },

  MuiDrawer: {
    styleOverrides: {
      paper: {
        borderRight: "1px solid #e0e0e0",
        backgroundColor: "#fafafa",
      },
    },
  },

  MuiListItem: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        margin: "4px 8px",
        "&.Mui-selected": {
          backgroundColor: alpha("#d32f2f", 0.1),
          color: "#d32f2f",
          "&:hover": {
            backgroundColor: alpha("#d32f2f", 0.15),
          },
        },
        "&:hover": {
          backgroundColor: alpha("#d32f2f", 0.05),
        },
      },
    },
  },

  MuiListItemIcon: {
    styleOverrides: {
      root: {
        minWidth: 40,
        ".Mui-selected &": {
          color: "#d32f2f",
        },
      },
    },
  },

  MuiTextField: {
    styleOverrides: {
      root: {
        "& .MuiOutlinedInput-root": {
          "&:hover fieldset": {
            borderColor: "#d32f2f",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#d32f2f",
          },
        },
      },
    },
  },

  MuiFormLabel: {
    styleOverrides: {
      root: {
        "&.Mui-focused": {
          color: "#d32f2f",
        },
      },
    },
  },

  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: "none",
        fontWeight: 500,
        fontSize: "0.875rem",
        minHeight: 48,
      },
    },
  },

  MuiTabs: {
    styleOverrides: {
      indicator: {
        backgroundColor: "#d32f2f",
        height: 3,
      },
    },
  },

  MuiDataGrid: {
    styleOverrides: {
      root: {
        border: "1px solid #e0e0e0",
        borderRadius: 8,
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: "#f5f5f5",
          borderBottom: "2px solid #d32f2f",
        },
        "& .MuiDataGrid-row:hover": {
          backgroundColor: alpha("#d32f2f", 0.05),
        },
      },
    },
  },

  MuiFab: {
    styleOverrides: {
      primary: {
        background: "linear-gradient(45deg, #d32f2f 30%, #f44336 90%)",
        "&:hover": {
          background: "linear-gradient(45deg, #b71c1c 30%, #d32f2f 90%)",
        },
      },
    },
  },

  MuiLinearProgress: {
    styleOverrides: {
      colorPrimary: {
        backgroundColor: alpha("#d32f2f", 0.2),
      },
      barColorPrimary: {
        backgroundColor: "#d32f2f",
      },
    },
  },

  MuiAlert: {
    styleOverrides: {
      standardError: {
        backgroundColor: alpha("#f44336", 0.1),
        color: "#b71c1c",
      },
      standardWarning: {
        backgroundColor: alpha("#ff9800", 0.1),
        color: "#e65100",
      },
      standardInfo: {
        backgroundColor: alpha("#2196f3", 0.1),
        color: "#0d47a1",
      },
      standardSuccess: {
        backgroundColor: alpha("#4caf50", 0.1),
        color: "#1b5e20",
      },
    },
  },

  MuiBreadcrumbs: {
    styleOverrides: {
      separator: {
        color: "#d32f2f",
        fontSize: "1rem",
      },
    },
  },

  MuiTreeItem: {
    styleOverrides: {
      root: {
        "& .MuiTreeItem-content": {
          borderRadius: 8,
          margin: "2px 0",
          "&:hover": {
            backgroundColor: alpha("#d32f2f", 0.05),
          },
          "&.Mui-selected": {
            backgroundColor: alpha("#d32f2f", 0.1),
            "&:hover": {
              backgroundColor: alpha("#d32f2f", 0.15),
            },
          },
        },
      },
    },
  },
};
